
export const tracks = {
  'Japan': [ 'lA0pgGNvmv4', 'gdZLi9oWNZg', 'NGcXJ-ypK3I', 'elRS0ntrEjk', 'gLXNJou6-DQ' ],
  'NYC': [ 'iY5j1fM-9DU', 'lE9KoKgekh4', 'C9yNSHtlg7g', 'QByNsl0SUAI', ],
  'France': [ 'Lguwm-zcbTs', 'lEfkziQSmZI', 'IFcxEfRO3n4', 'D9znOPZX5MQ' ],
  'Germany': ['M9zSFf63hDM', 'FR5co0KKmlE', 'iwGKiDsfXlU', 'UCbmg6yDqww' ],
  'India': [ 'Q48tagwurUw', '_S__Nu_5KSU', 'hJBHSmyqv0Y', 'UCbmg6yDqww' ],
  'Italy': [ 'wwsIGR11YmY', '8wlxTdDol70', 'U7hY7VVm7FQ', 'sNYuwmQCn-s' ],
}

export const locations = {
  'NYC': [ 
    {'id': 'n493bDy2W-U', 'name': 'Times Square'}, 
    {'id': 'YGqD6kLs_-c', 'name': 'Grand Central'}, 
    {'id': '8sVOncVFJfA', 'name': 'Lower Manhattan'}, 
    {'id': 'xzQW_ri7zwE', 'name': 'Rockefeller Plaza'}, 
  ],
  'France': [ 
    { 'id': 'udpuCudGU8Y', 'name': 'Paris in Autumn' }, 
    { 'id': 'QbvED3eUfk8', 'name': 'Eiffel Tower' }, 
    { 'id': "kGgmQQ_wOkU", 'name': 'Village Royale' }, 
    { 'id': 'F1KgfE1OGz8', 'name': 'Hotel De Ville to Notre Dame' } 
  ],
  'Germany': [ 
    { 'id': 'Xq79kGuXpH4', 'name': 'Dresden' },  
    { 'id': '4lOzYUlhJEw', 'name': 'Munich' }, 
    { 'id': '3VgJVB3OD3g', 'name': 'Meersburg' }, 
    { 'id': 'M6MOMNKbcoM', 'name': 'Berlin'}, 
  ],
  'Japan': [ 
    {'id': 'n3Dru5y3ROc', 'name': 'Tokyo, Red Light District'}, 
    {'id': '0nTO4zSEpOs', 'name': 'Shibuya'}, 
    {'id': 'q48xVf-AbmA', 'name': 'Kyoto'}, 
    {'id': '5mbh1wZSweo', 'name': 'Asakusa'}, 
  ], 
  'India': [ 
    {'id': 'nR22Inj-_r8', 'name': 'Taj Mahal'}, 
    {'id': 'XRU9omrRV64', 'name': 'Ganges'}, 
    {'id': 'XVvYXBTSuaA', 'name': 'New Delhi, Paharganj'}, 
    {'id': 's6lfvfe1i4g', 'name': 'Diwali'}, 
  ],
  'Italy': [ 
    {'id': 'xrRFKEdtQIc', 'name': 'Milan'},  
    {'id': 'P9uMtDLhXbE', 'name': 'Trastevere'},  
    {'id': 'EsFheWkimsU', 'name': 'Rome'},  
    {'id': '17xMrhDD87c', 'name': 'Genoa'},  
  ]
}
